import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';

import { finalize } from 'rxjs/operators';
import { FavoriteApi } from 'src/app/_shared/api/favorite.api';
import { Json } from 'src/app/_shared/interface/common.interface';
import { FavoriteState } from 'src/app/_shared/state/favorite.state';
import { SubscriptionState } from 'src/app/_shared/state/subscription.state';
import { UserState } from 'src/app/_shared/state/user.state';
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';
import constants from 'src/constant.json';
import { environment } from 'src/environments/environment';
import { FavoriteGroupNameList, UpdateGroup } from '../follow-property-interface';
import { FollowedPropertiesState } from '../state/followed-properties.state';

@Injectable({
  providedIn: 'root',
})
export class FollowedPropertiesService {
  $favoriteGroupList = new BehaviorSubject<any>({});
  favoriteGroupList = this.$favoriteGroupList.asObservable();

  constructor(
    private favoriteApi: FavoriteApi,
    private favoriteState: FavoriteState,
    private followedState: FollowedPropertiesState,
    private http: HttpClient,
    private storage: LocalStorageService,
    private subscriptionState: SubscriptionState,
    private userState: UserState
  ) {}

  deleteFavorite(favoriteList: any): Observable<any> {
    const params = {
      favoriteList: favoriteList,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.deleteFavorite, params).subscribe(
        (res) => {
          let planUsageValue: any = this.subscriptionState.planUsageValue;
          planUsageValue.favoriteUsage = planUsageValue.favoriteUsage - favoriteList.length;
          this.subscriptionState.planUsageValue = planUsageValue;
          observer.next({ status: true, message: res.Message ? res.Message : '' });
        },
        (err) => {
          observer.error({
            status: false,
            message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
          });
        }
      );
    });
  }

  copyFavorite(GroupId: string[], favoriteList: string[]): Observable<any> {
    const params = {
      followGroupList: GroupId,
      favoriteList: favoriteList,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.copyFavorite, params).subscribe(
        (res) => {
          if (res) {
            if (res.data) {
              observer.next({ status: res.status, data: res.data, message: res.Message });
            } else {
              observer.next({ status: true, message: res.Message ? res.Message : '' });
            }
          } else {
            observer.error({ status: false, message: 'Error occurred' });
          }
        },
        (err) => {
          observer.error({
            status: false,
            message: err.error && err.error.Message ? err.error.Message : 'Error occurred',
          });
        }
      );
    });
  }

  moveFavorite(GroupId: string[], favoriteList: string[]): Observable<any> {
    const params = {
      favoriteList: favoriteList,
      followGroupList: GroupId,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.moveFavorite, params).subscribe(
        (res) => {
          observer.next({ status: true, message: res.Message ? res.Message : '' });
        },
        (err) => {
          observer.error({
            status: false,
            message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
          });
        }
      );
    });
  }

  listFavoriteGroup(): Observable<{ isLoading: boolean }> {
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.http
        .post<FavoriteGroupNameList>(environment.prospektrBackendBaseURL + constants.API.listFavoriteGroup, null)
        .pipe(
          finalize(() => {
            observer.next({ isLoading: false });
          })
        )
        .subscribe((res) => {
          if (res && res.groupsList) {
            this.$favoriteGroupList.next({
              status: true,
              groupsList: this.formatGroupNameObj(res.groupsList),
              groupsListCount: res['totalCount'],
            });
            this.favoriteState.followGroupListValue = this.formatGroupNameObj(res.groupsList);
          } else {
            this.favoriteState.followGroupListValue = [];
          }
        });
    });
  }

  // listFavoritePropertyId(params): Observable<any> {
  //   return new Observable((observer) => {
  //     this.http
  //       .post<any>(
  //         environment.prospektrBackendBaseURL + constants.API.listFavoriteGroupPropertyId,
  //         params,
  //         this.httpOptions
  //       )
  //       .subscribe(
  //         (res) => {
  //           if (res && res.data) {
  //             observer.next({
  //               status: true,
  //               favoritePropertyId: res.data,
  //             });
  //           }
  //         },
  //         (err) => {
  //           observer.error({
  //             status: false,
  //           });
  //         }
  //       );
  //   });
  // }

  fetchFavoritesByGroup(groupId: string, options: Json): Observable<{ isLoading: boolean }> {
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.favoriteApi
        .fetchFavoriteByGroup(groupId, options)
        .pipe(
          finalize(() => {
            observer.next({ isLoading: false });
          })
        )
        .subscribe((res) => {
          this.followedState.favoritePropertiesByGroupValue = { data: res?.data, totalCount: res?.totalCount };
        });
    });
  }

  fetchFavoriteIdsByGroup(groupId: string): Observable<{ isLoading: boolean; data?: Array<string> }> {
    let response = null;
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.favoriteApi
        .fetchFavoriteIdsByGroup(groupId)
        .pipe(
          finalize(() => {
            observer.next({ isLoading: false, data: response });
          })
        )
        .subscribe((res) => {
          response = res?.data || [];
        });
    });
  }

  getAllFavoritePropertyInGivenGroup(inputParams: any): Observable<any> {
    const params = {
      id: inputParams.groupId,
      orderBy: inputParams.orderBy,
      orderType: inputParams.orderType,
      limit: inputParams.limit,
      offset: inputParams.offset,
    };

    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + 'listFavoriteGroupProperty', params).subscribe(
        (res) => {
          if (res && res.groupResult) {
            res.groupResult = JSON.parse(JSON.stringify(res.groupResult)).map((el) => ({
              ...el,
              date:
                moment(new Date()).diff(moment(el.createdDate), 'hours') < 24
                  ? moment(el.createdDate).fromNow()
                  : moment(el.createdDate).format('MMMM D, YYYY'),
              LastSaleContractDate: el.LastSaleContractDate
                ? moment(new Date()).diff(moment(el.LastSaleContractDate), 'hours') < 24
                  ? moment(el.LastSaleContractDate).fromNow()
                  : moment(el.LastSaleContractDate).format('MMMM D, YYYY')
                : null,
              Address:
                el.Address && el.Address.lastIndexOf(', USA')
                  ? el.Address.substring(0, el.Address.lastIndexOf(', USA'))
                  : null,
            }));
            observer.next({
              status: true,
              favPropertyCount: res.totalCount,
              favPropertyList: res.groupResult,
            });
          }
        },
        (err) => {
          observer.error({
            status: false,
            message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
          });
        }
      );
    });
  }

  formatGroupNameObj(groups): Array<any> {
    return groups && groups.length
      ? JSON.parse(JSON.stringify(groups)).map((el) => ({
          ...el,
          newName: '',
          editGroupName: false,
          fromNow:
            moment(new Date()).diff(moment(el.createdDate), 'hours') < 24
              ? moment(el.createdDate).fromNow()
              : moment(el.createdDate).format('MMMM D, YYYY'),
        }))
      : [];
  }

  unFollowPropertyWithId(propertyId: string): Observable<any> {
    const params = {
      id: propertyId,
    };
    return new Observable((observer) => {
      this.http
        .post<any>(environment.prospektrBackendBaseURL + constants.API.unfollowPropertyFromGivenGroup, params)
        .subscribe(
          (res) => {
            observer.next({ status: true, message: res.Message ? res.Message : '' });
          },
          (err) => {
            // console.log('err ::::', err);
            observer.error({
              status: false,
              message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
            });
          }
        );
    });
  }

  copyOrMoveGivenFollowedProperty(propertyId: string, action: string, groupId: string): Observable<any> {
    const params = {
      id: propertyId,
      type: action,
      newGroupId: groupId,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.manageFollowProperty, params).subscribe(
        (res) => {
          observer.next({ status: true, message: res.Message ? res.Message : '' });
        },
        (err) => {
          // console.log('err ::::', err);
          observer.error({
            status: false,
            message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
          });
        }
      );
    });
  }

  updateGroupName(data: UpdateGroup): Observable<any> {
    const params = {
      id: data.groupId,
      name: data.name,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.updateFollowGroupName, params).subscribe(
        (res) => {
          observer.next({ status: res.status || 'error', message: res.Message || 'Some error occurred' });
        },
        (err) => {
          observer.error({
            status: false,
            message: err && err.error && err.error.Message ? err.error.Message : 'Error occurred while loading',
          });
          // console.log('err ::::', err);
        }
      );
    });
  }

  deletFollowGroup(groupId): Observable<any> {
    const params = {
      id: groupId,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.deleteFollowGroup, params).subscribe(
        (res) => {
          if (res) {
            observer.next({ status: true, message: res.Message ? res.Message : '' });
          } else {
            observer.error({ status: false, message: 'Error occurred' });
          }
        },
        (err) => {
          observer.error({
            status: false,
            message: err.error && err.error.Message ? err.error.Message : 'Error occurred',
          });
        }
      );
    });
  }

  createNewFollowGroup(groupName): Observable<any> {
    const params = {
      name: groupName,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.createFollowGroup, params).subscribe(
        (res) => {
          if (res && res.groupResult && res.Message) {
            observer.next({
              status: true,
              message: res.Message,
              groupId: res.groupResult.id,
              groupResult: res.groupResult,
            });
          } else {
            observer.error({ status: false, message: res.Message ? res.Message : 'Error occurred' });
          }
        },
        (err) => {
          observer.error({
            status: false,
            message: err.error && err.error.Message ? err.error.Message : 'Error occurred',
          });
        }
      );
    });
  }

  followSelectedProperties(GroupId: string[], property: string[]): Observable<any> {
    const params = {
      followGroupList: GroupId,
      propertiesList: property,
    };
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.followPropertiesList, params).subscribe(
        (res) => {
          if (res) {
            if (res.data) {
              observer.next({ status: res.status, data: res.data, message: res.Message });
            } else {
              observer.next({ status: true, message: res.Message ? res.Message : '' });
            }
          } else {
            observer.error({ status: false, message: 'Error occurred' });
          }
        },
        (err) => {
          observer.error({
            status: false,
            message: err.error && err.error.Message ? err.error.Message : 'Error occurred',
          });
        }
      );
    });
  }

  curUpdatedGroupNameListAfterDelete(followGroupNameList, groupId): Array<any> {
    const index = followGroupNameList.findIndex((el) => el.id === groupId);
    if (index !== -1) {
      followGroupNameList.splice(index, 1);
    }
    return followGroupNameList;
  }

  curUpdatedGroupNameListAfterAdding(followGroupNameList, newGroupResObj): Array<any> {
    followGroupNameList = followGroupNameList ? followGroupNameList : [];
    followGroupNameList.unshift(newGroupResObj);
    return this.formatGroupNameObj(followGroupNameList);
  }

  postFollowGroupIdToExternalServer(id: string): Observable<any> {
    const settings = this.storage.exportingDetails;
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }),
    };
    if (settings.accessToken) {
      httpOptions.headers = httpOptions.headers.set('Access-Token', settings.accessToken);
    }
    const params: { userName: string; listId: string } = {
      listId: id,
      userName: this.userState.userDetails?.userName,
      // 'nextqms@gmail.com'
    };
    return new Observable((observer) => {
      this.http.post(settings.endPoint, params, httpOptions).subscribe(
        (res) => {
          if (res) {
            observer.next({ message: 'Successfully exported', status: true });
          }
        },
        (err) => {
          observer.next({
            message: err.error && err.error.message ? err.error.message : 'Something went wrong',
            status: false,
          });
        }
      );
    });
  }

  exportFavoritesToCSV(params): Observable<any> {
    return new Observable((observer) => {
      this.http.post<any>(environment.prospektrBackendBaseURL + constants.API.exportFavoritesToCSV, params).subscribe(
        (res) => {
          observer.next(res);
        },
        (err) => {
          observer.next(err.error);
        }
      );
    });
  }
}
